import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ApiMembresiaResponse } from '../types/API.types';
import { environment } from '../environments/environment';
import { SeoContent } from '../types/seo-content.types';

@Injectable({
  providedIn: 'root',
})
export class SeoContentService {
  private apiUrl = `${environment.apiUrl}/${environment.apiVersion}`;
  private http = inject(HttpClient);

  getSeoContent(path: string) {
    const url = `${this.apiUrl}${environment.endpoints.seoContent}`;
    let params = new HttpParams();
    params = params.set('path', path);
    return this.http
      .get<ApiMembresiaResponse<SeoContent[]>>(url, { params })
      .pipe(
        map((response) => {
          const data = response?.data;
          if (!data) return null;

          const [first] = data;
          if (!first) return null;

          return first;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }
}
